import React, { useMemo } from 'react'
import { PlayerStats as PlayerStatsType } from 'types/global'
import { getLastPlayedDays } from 'utils/date-utils'
import ProfilePanel, { DataListItem } from './generic/profile-panel/ProfilePanel'
import { useTranslation } from 'react-i18next'
import { getDataListValueFields } from './generic/profile-panel/utils'

const MatchActivity: React.FC<PlayerStatsType> = ({
  lastPlayedSingles,
  lastPlayedDoubles,
  uniqueOpponents,
  singlesInterval,
  doublesInterval,
}) => {
  const { t } = useTranslation(['strPlayerStats', 'strData', 'strCommonUI'])

  const matchActivityItems: DataListItem[] = useMemo(() => {
    const fallbackValue = t('na', { ns: 'strData' })
    const fallbackAriaLabel = t('ariaLabel.noData', { ns: 'strCommonUI' })

    return [
      {
        label: t('uniqueSinglesTitle', { ns: 'strPlayerStats' }),
        ...getDataListValueFields(uniqueOpponents?.toString(), {
          fallbackValue,
          fallbackAriaLabel,
        }),
      },
      {
        label: t('daysSinceLastMatchTitle', { ns: 'strPlayerStats' }),
        ...getDataListValueFields(
          lastPlayedSingles || lastPlayedDoubles
            ? t('text.daysCount', {
                ns: 'strCommonUI',
                count: getLastPlayedDays(lastPlayedSingles, lastPlayedDoubles),
              })
            : undefined,
          {
            fallbackValue,
            fallbackAriaLabel,
          }
        ),
      },
      {
        label: t('singlesIntervalTitle', { ns: 'strPlayerStats' }),
        ...getDataListValueFields(
          typeof singlesInterval === 'number'
            ? t('text.daysCount', { ns: 'strCommonUI', count: singlesInterval })
            : undefined,
          {
            fallbackValue,
            fallbackAriaLabel,
          }
        ),
      },
      {
        label: t('doublesIntervalTitle', { ns: 'strPlayerStats' }),
        ...getDataListValueFields(
          typeof doublesInterval === 'number'
            ? t('text.daysCount', { ns: 'strCommonUI', count: doublesInterval })
            : undefined,
          {
            fallbackValue,
            fallbackAriaLabel,
          }
        ),
      },
    ]
  }, [t, uniqueOpponents, lastPlayedSingles, lastPlayedDoubles, singlesInterval, doublesInterval])

  return (
    <ProfilePanel title={t('matchActivityTitle', { ns: 'strPlayerStats' })}>
      <ProfilePanel.DataList items={matchActivityItems} />
    </ProfilePanel>
  )
}

export default MatchActivity
